import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import ValidationMixin from "@cirrus/legacy/app-components/validations/validation-mixin/index.jsx"
import Icon from "@cirrus/legacy/app-components/icons/icon/index.jsx"

import styles from "./searchInput.less"

class StatelessTextInput extends C {
  static propTypes = {
    dataQa: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    tabIndex: PropTypes.number,
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    onKeyUp: PropTypes.func,
    onChange: PropTypes.func,
    onCopy: PropTypes.func,
    onBlur: PropTypes.func,
    maxLength: PropTypes.number,
    type: PropTypes.string,
  }

  static defaultProps = {
    type: "text",
  }

  handleChange(e) {
    this.props.onChange && this.props.onChange(e, e.target.value)
  }

  render() {
    const containerClassName = classnames(styles.container, this.props.containerClassName)

    let inputClass = classnames(styles.input, this.props.className, {
      disabled: this.props.disabled,
    })
    const iconClass = classnames(styles.icon, this.props.iconClassName)

    return (
      <div className={containerClassName}>
        <input
          id={this.props.id}
          data-qa={this.props.dataQa}
          type={this.props.type}
          className={inputClass}
          value={this.props.value}
          onKeyUp={this.props.onKeyUp}
          onChange={this.handleChange.bind(this)}
          onCopy={this.props.onCopy}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
          tabIndex={this.props.tabIndex}
          autoFocus={this.props.autoFocus}
          onBlur={this.props.onBlur}
          maxLength={this.props.maxLength}
          name={this.props.name}
        />
        <Icon icon="fa-search" className={iconClass} />
      </div>
    )
  }
}

export default ValidationMixin(StatelessTextInput)
